// extracted by mini-css-extract-plugin
export var borderRadius = "_5n-4";
export var large = "_5n-3";
export var logoContainer = "_5n-0";
export var nameLogo = "_5n-2";
export var small = "_5n-1";